import { notify } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useRemoveAttachmentOwnerReference } from '@features/attachments/hooks/useRemoveAttachmentOwnerReference'
import { useInvalidateTransactions } from '@features/transactions/hooks/useInvalidateTransactions'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useInvalidateBills } from './useInvalidateBills'

export const useDeleteBillAttachment = (billId: string) => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { invalidateBill } = useInvalidateBills()
  const { invalidateTransactions } = useInvalidateTransactions()
  const { remove } = useRemoveAttachmentOwnerReference()

  const deleteAttachment = useCallback(
    (attachmentId: string) => {
      remove(
        { attachmentId, organizationId: organization?.id as string },
        {
          onSuccess: () => {
            invalidateBill(billId)
            invalidateTransactions()
            notify({
              id: 'bill-attachment-remove',
              message: t('bill.notification.attachments_update_success'),
              variant: 'success',
            })
          },
          onError: () => {
            notify({
              id: 'bill-attachment-remove',
              message: t('bill.notification.attachments_update_error'),
              variant: 'error',
            })
          },
        },
      )
    },
    [remove, organization?.id, billId, invalidateBill, invalidateTransactions, t],
  )

  return { deleteAttachment }
}
